export type SiteType = "dmr" | "pmr446" | "planned" | "none" | "unknown";
export type BusinessUnit = "FC" | "AMZL" | "AMXL" | "ATS" | "VENDORFLEX" | "SORTCENTER" | "OTHER";
export type SiteStatus = "active" | "provisioning" | "maintenance" | "planned" | "decommissioned";
export type CountryISO2 = "DE" | "AT" | "FR" | "IT" | "ES" | "PL" | "CZ" | "SK";

export interface Site {
  code: string;
  country: CountryISO2;
  bu: BusinessUnit;
  site_type: SiteType;
  repeaters: number;
  status: SiteStatus;
  lat: number;
  lon: number;
  address: string | null;
}

export const COUNTRY_NAMES: Record<CountryISO2, string> = {
  DE: "Germany",
  AT: "Austria",
  FR: "France",
  IT: "Italy",
  ES: "Spain",
  PL: "Poland",
  CZ: "Czechia",
  SK: "Slovakia",
};

export const BU_LABELS: Record<BusinessUnit, string> = {
  FC: "Fulfillment Center",
  AMZL: "Last-Mile / AMZL",
  AMXL: "Heavy & Bulky / AMXL",
  ATS: "Transport / ATS",
  VENDORFLEX: "Vendor Flex",
  SORTCENTER: "Sort Center",
  OTHER: "Other",
};
